import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useApp } from '@/lib/store';
import { Logo } from '@/components/Logo';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const setUser = useApp((s) => s.setUser);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate('/app', { replace: true }); return; }
      try {
        const user = await api.session(sessionId);
        setUser(user);
        window.history.replaceState({}, document.title, '/app');
        navigate('/app', { replace: true });
      } catch (e) {
        navigate('/app/account', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--background)' }}>
      <div className="flex flex-col items-center gap-3">
        <Logo size={32} />
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Signing you in…</p>
      </div>
    </div>
  );
}
